import { Row, Col, Typography, Image, Card, Button, ConfigProvider } from "antd";
import { IresponseAgendes } from "../../common";
import Logo from "../../../../assets/images/osd_logo.png";

export interface Props {
  onChangeCurrentStep: (step: number) => void;
  currentStep: number;
  stepsLength: number;
}
const { Title, Text } = Typography;
export const EconnectStepTwo: React.FC<Props> = ({
  onChangeCurrentStep,
  currentStep,
  stepsLength,
}): React.ReactElement => {
  return (
    <div  className="h-screen overflow-y-auto" >
      <Row>
        <Col>
          <Card>
            <br />
            <div >
              <div className="flex justify-center pb-[20px]">
                <Image src={Logo} width={93} preview={false} />
              </div>
              <div className="text-center mt-[5px]">
                <Typography className="font-bold text-[16px] w-full text-[#160C65]">{`Personal Data Processing Consent`}</Typography>
              </div>
              <br></br>
              <div className="rounded-[8px] border-[0.5px] text-[#54565A] font-light border-grey border-groove p-[10px] md:h-[400px] h-[300px] text-grey overflow-x-auto text-[14px]">
                <div className=" font-bold ">Thailand Privacy Policy</div>
                <br></br>
                <div >
                  {`At O S D Co., Ltd., our mission is to empower businesses by offering optimal digital solutions that lead to improved outcomes and enhanced customer satisfaction. Your trust is essential to us, and to demonstrate our commitment, we are providing you with the following information regarding the data we collect from you and how we utilize it to deliver the best possible experience.
This Privacy Policy describes our practices in connection with information that we collect through activities that link to this Privacy Policy including websites (our “Websites”) and any mobile sites, web applications, and other mobile interactive features (collectively, our “Web Apps”), through other services that we may offer in connections with our Websites and Web Apps, such as promotions, rewards programs, through our official social media pages that we control (our “Social Media Pages”), as well as through HTML-formatted email messages that we send to you (collectively, including the Social Media Pages, Apps and Websites, the “Sites”).
By providing Personal Information to us, you agree to and explicitly consent to the terms and conditions of this Privacy Policy.
Ensuring the utmost privacy is a top priority for us, but what truly matters to us is the sincere dedication we have towards nurturing our relationship with you.ion is to empower businesses by offering optimal digital solutions that lead to improved outcomes and enhanced customer satisfaction. Your trust is essential to us, and to demonstrate our commitment, we are providing you with the following information regarding the data we collect from you and how we utilize it to deliver the best possible experience.This Privacy Policy describes our practices in connection with information that we collect through activities that link to this Privacy Policy including websites (our “Websites”) and any mobile sites, web applications, and other mobile interactive features (collectively, our “Web Apps”), through other services that we may offer in connections with our Websites and Web Apps, such as promotions, rewards programs, through our official social media pages that we control (our “Social Media Pages”), as well as through HTML-formatted email messages that we send to you (collectively, including the Social Media Pages, Apps and Websites, the “Sites”). `}
                </div>
              </div>
              <div className="flex justify-center items-center mt-2 mb-2">
                <Typography className="text-grey mt-2.5 text-[90%] text-center text-[#54565A]">{`I have read and understood the above consent request and terms and conditions.`}</Typography>
              </div>
            </div>
            <div className="flex justify-center items-center w-full pt-2">
              <div className="flex w-full gap-[5px]">
                {currentStep > 0 && currentStep === 1 && (
                  <div className="w-full">
                    <Button
                      className="rounded-[5px] w-full"
                      size="large"
                      onClick={() => onChangeCurrentStep(currentStep - 1)}
                    >
                      I do not consent
                    </Button>
                  </div>
                )}
                {currentStep < stepsLength - 1 &&
                  currentStep !== 0 &&
                  currentStep === 1 && (
                    <div className="flex w-full gap-[10px]">
                      <ConfigProvider
                        theme={{ token: { colorPrimary: "#160C65" } }}
                      >
                        <Button
                          type="primary"
                          className="text-white w-full rounded-[5px]"
                          size="large"
                          onClick={() => onChangeCurrentStep(currentStep + 1)}
                        >
                          {`I consent`}
                        </Button>
                      </ConfigProvider>
                    </div>
                  )}
              </div>
            </div>
          </Card>
        </Col>
      </Row>
    </div>
  );
};
